// Kiosk button. All kiosk buttons are `type="button"` (the SPA has no
// forms). Variants map to the .btn--* classes in components.css.

import type { ButtonHTMLAttributes, ReactNode } from "react";

type Variant = "primary" | "navy" | "secondary" | "ghost" | "danger";
type Size = "md" | "lg" | "xl";

type ButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "type"> & {
  variant?: Variant;
  size?: Size;
  block?: boolean;
  icon?: ReactNode;
};

const SIZE_CLASS: Record<Size, string> = {
  md: "",
  lg: "btn--lg",
  xl: "btn--xl",
};

export function Button({
  variant = "primary",
  size = "md",
  block = false,
  icon,
  children,
  className,
  ...rest
}: ButtonProps) {
  const classes = [
    "btn",
    `btn--${variant}`,
    SIZE_CLASS[size],
    block ? "btn--block" : "",
    className ?? "",
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <button className={classes} type="button" {...rest}>
      {icon ? <span className="btn__icon">{icon}</span> : null}
      {children}
    </button>
  );
}
